import { __decorate, __extends } from "tslib";
import { CustomElement, attachShadowTemplate, upgradeProperty, coerceBoolean } from '@tyler-components-web/core';
import { TabAdapter } from './tab-adapter';
import { TabFoundation } from './tab-foundation';
import { TAB_CONSTANTS } from './tab-constants';
var template = require('./tab.html');
var styles = require('./tab.css');
var TabComponent = /** @class */ (function (_super) {
    __extends(TabComponent, _super);
    function TabComponent() {
        var _this = _super.call(this) || this;
        attachShadowTemplate(_this, TAB_CONSTANTS.elementName, template, styles);
        _this._foundation = new TabFoundation(new TabAdapter(_this));
        return _this;
    }
    Object.defineProperty(TabComponent, "observedAttributes", {
        get: function () {
            return [
                TAB_CONSTANTS.attributes.DISABLED,
                TAB_CONSTANTS.attributes.ACTIVE,
                TAB_CONSTANTS.attributes.STRETCH,
                TAB_CONSTANTS.attributes.FOCUS_ON_ACTIVATE
            ];
        },
        enumerable: true,
        configurable: true
    });
    TabComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'disabled');
        upgradeProperty(this, 'active');
        upgradeProperty(this, 'stretch');
        upgradeProperty(this, 'focusOnActivate');
    };
    TabComponent.prototype.connectedCallback = function () {
        this._foundation.initialize();
    };
    TabComponent.prototype.disconnectedCallback = function () {
        this._foundation.disconnect();
    };
    TabComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case TAB_CONSTANTS.attributes.DISABLED:
                this.disabled = this.hasAttribute(TAB_CONSTANTS.attributes.DISABLED);
                break;
            case TAB_CONSTANTS.attributes.ACTIVE:
                this.active = this.hasAttribute(TAB_CONSTANTS.attributes.ACTIVE);
                break;
            case TAB_CONSTANTS.attributes.STRETCH:
                this.stretch = this.hasAttribute(TAB_CONSTANTS.attributes.STRETCH);
                break;
            case TAB_CONSTANTS.attributes.FOCUS_ON_ACTIVATE:
                this.focusOnActivate = coerceBoolean(newValue);
                break;
        }
    };
    Object.defineProperty(TabComponent.prototype, "disabled", {
        get: function () {
            return this._foundation.disabled;
        },
        set: function (value) {
            this._foundation.disabled = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TabComponent.prototype, "active", {
        get: function () {
            return this._foundation.active;
        },
        set: function (value) {
            this._foundation.active = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TabComponent.prototype, "stretch", {
        get: function () {
            return this._foundation.stretch;
        },
        set: function (value) {
            this._foundation.stretch = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TabComponent.prototype, "focusOnActivate", {
        get: function () {
            return this._foundation.focusOnActivate;
        },
        set: function (value) {
            this._foundation.focusOnActivate = value;
        },
        enumerable: true,
        configurable: true
    });
    TabComponent.prototype.activate = function (previousIndicatorClientRect) {
        this._foundation.activate(previousIndicatorClientRect);
    };
    TabComponent.prototype.deactivate = function () {
        this._foundation.deactivate();
    };
    TabComponent.prototype.computeIndicatorBounds = function () {
        return this._foundation.computeIndicatorBounds();
    };
    TabComponent.prototype.computeDimensions = function () {
        return this._foundation.computeDimensions();
    };
    TabComponent.prototype.focus = function () {
        this._foundation.focus();
    };
    TabComponent.prototype.setTabIndex = function (value) {
        this._foundation.setTabIndex(value);
    };
    TabComponent = __decorate([
        CustomElement({
            name: TAB_CONSTANTS.elementName
        })
    ], TabComponent);
    return TabComponent;
}(HTMLElement));
export { TabComponent };
